import { gql } from '$lib/apollo';

export const COACH_ACHIEVEMENT_MUTATION_FIELDS = gql`
  fragment CoachAchievementFields on API_CoachAchievement {
    id
    type
    achievement
    tournamentTitle
    placement
    year
    position
    game {
      id
      slug
      localizedShortTitles {
        en
      }
      localizedTitles {
        en
      }
      logoMain {
        original {
          url
        }
      }
    }
  }
`;

export const ADD_COACH_ACHIEVEMENT = gql`
  mutation AddCoachAchievement($input: AccountAchievementCreateInput!) {
    accountAchievementCreate(input: $input) {
      result {
        ...CoachAchievementFields
      }
    }
  }
  ${COACH_ACHIEVEMENT_MUTATION_FIELDS}
`;

export const EDIT_COACH_ACHIEVEMENT = gql`
  mutation EditCoachAchievement($input: AccountAchievementUpdateInput!) {
    accountAchievementUpdate(input: $input) {
      result {
        ...CoachAchievementFields
      }
    }
  }
  ${COACH_ACHIEVEMENT_MUTATION_FIELDS}
`;

export const REMOVE_COACH_ACHIEVEMENT = gql`
  mutation RemoveCoachAchievement($input: AccountAchievementDeleteInput!) {
    accountAchievementDelete(input: $input) {
      result
    }
  }
`;
